// 应用信息
import {App, app_query_one, app_upsert} from '../db/t_app';
import Context from './context';
import time from '../time';
import log from '../log';

export class AppController {
    // 同步查询，优先取缓存本地的数据，本地的数据创建时间超过10分钟，强制更新一次
    public static async QryOneSync(
        ctx: Context,
        appkey: string,
    ): Promise<{error: any; app?: App}> {
        const r = await app_query_one(ctx.db, appkey);
        if (r.error) {
            return {error: r.error};
        }
        if (r.app) {
            // 上一次更新时间超过了20分钟了
            const exp = time.toUnixMillSecond(
                time.add(time.now(), -20 * time.MINUTE),
            );
            if (r.app.lutime > exp) {
                return r;
            }
        }

        // 调后台接口查一把
        const rsp = await ctx.conn.Call('/v1/sdk/company/detail', {
            appkey: appkey,
        });
        if (!(rsp && rsp.code === 0)) {
            log.warn('查询应用信息失败', appkey, JSON.stringify(rsp));
            return {error: rsp};
        }
        if (!(rsp && rsp.data && rsp.data.app)) {
            log.warn('查询应用信息为空', appkey, JSON.stringify(rsp));
            return {error: null};
        }

        log.info('查询应用信息为', appkey, JSON.stringify(rsp.data.app));
        const app = rsp.data.app as App;
        log.info('查询应用信息为', appkey, JSON.stringify(app));
        await app_upsert(ctx.db, app); // 入库
        return {error: null, app: app};
    }
}
